import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider/LocalizationProvider';
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import { InputAdornment } from '@material-ui/core';
import { Search } from '@material-ui/icons';

interface IDateTimeFilterProps {
  filterName: string,
  handleChange: () => void,
  value: Date
}
const DateTimeFilter = ({handleChange, value}: IDateTimeFilterProps) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DateTimePicker
        timeSteps={{minutes: 1}}
        disableFuture
        ampm={false}
        slotProps={{
            textField: {
            error: false,
            variant: 'standard',
            size: 'small',
            InputProps: {
              disabled:true,
              readOnly: true,
              startAdornment: (
                <InputAdornment position="start">
                  <Search fontSize="small"/>
                </InputAdornment>
              )
            }
            },
          actionBar: {
            actions: ['clear', 'accept']
          } 
        }}
        value={value}
        sx={{marginTop: '2px', paddingRight: 1}}
        onAccept={handleChange}
      />    
    </LocalizationProvider>
  );
}

export default DateTimeFilter